import {COLORS} from '../../../../constants/colors';

export const badgeColors = {
  colors: {
    default: COLORS.Black,
    sale: COLORS.White,
  },
  backgroundColors: {
    default: COLORS.White,
    basket: COLORS.Green,
    sale: COLORS.RedSale,
    campaign: COLORS.RedSale,
  },
};
